import { useRecentActivity, type UserActivityType } from '../hooks';

/**
 * RecentActivity - Últimas interações do usuário
 *
 * Exibe lista de atividades recentes com tipo, descrição e tokens gastos
 * Migrado para Tailwind CSS v4
 */
export const RecentActivity = () => {
  // Fetch real activities from API
  const { activities } = useRecentActivity(4);

  const getActivityIcon = (type: UserActivityType) => {
    switch (type) {
      case 'chat':
        return '💬';
      case 'project':
        return '📁';
      default:
        return '📌';
    }
  };

  const getActivityIconBg = (type: UserActivityType) => {
    switch (type) {
      case 'chat':
        return 'bg-[#3b82f6]/10';
      case 'project':
        return 'bg-[#8b5cf6]/10';
      default:
        return 'bg-[#6b7280]/10';
    }
  };

  return (
    <div className="bg-[#2a2a2a] rounded-xl p-6 border border-[#333333] hover:border-[#F4CC04] transition-all duration-400">
      {/* Header */}
      <div className="mb-6">
        <div className="text-sm font-medium text-[#999999] mb-2 m-0">Atividade Recente</div>
        <div className="text-2xl font-bold text-white m-0">Últimas interações</div>
      </div>

      {/* Activity List */}
      <div className="space-y-3">
        {activities.map((activity, index) => (
          <div
            key={activity.id}
            className="flex items-start gap-4 p-4 bg-[#1a1a1a] rounded-lg hover:bg-[#222222] transition-colors cursor-pointer animate-fadeInUp"
            style={{ animationDelay: `${index * 100}ms` }}
          >
            {/* Icon */}
            <div className={`w-11 h-11 rounded-lg ${getActivityIconBg(activity.type)} flex items-center justify-center flex-shrink-0`}>
              <span className="text-2xl">{getActivityIcon(activity.type)}</span>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <div className="text-base font-semibold text-white mb-1.5 truncate m-0">
                {activity.title}
              </div>
              <div className="text-sm text-[#999999] m-0">{activity.description}</div>
            </div>

            {/* Tokens */}
            <div className="flex-shrink-0 text-right">
              <span className="text-base font-bold text-[#F4CC04] m-0">
                +{activity.tokensUsed.toLocaleString('pt-BR')}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
